import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/Login/NewStudentLogin",
    method: "post",
    data
  });
}
export function loginBackstage(data) {
  return request({
    url: "/LoginManagement/GetUserDisplay",
    method: "get",
    data
  });
}
